export default "__VITE_ASSET__LodAhVlk__"